@import (reference) '../../../../constants/spacing.module.less';

.tags-container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: @space-16;
  flex: 1;
}

.divider {
  border-color: var(--default--border-color--10);
  height: 20px;
}
